import { render, staticRenderFns } from "./Configure3DModelScale.vue?vue&type=template&id=1771c8ea&scoped=true"
import script from "./Configure3DModelScale.vue?vue&type=script&lang=js"
export * from "./Configure3DModelScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1771c8ea",
  null
  
)

export default component.exports